"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForkStateManager = void 0;
const rlp_1 = require("@ganache/rlp");
const cache_1 = require("./cache");
const state_manager_1 = require("../state-manager");
/**
 * Interface for getting and setting data from an underlying
 * state trie.
 */
class ForkStateManager extends state_manager_1.GanacheStateManager {
    /**
     * Instantiate the StateManager interface.
     */
    constructor(opts) {
        super(opts);
        this._cache = new cache_1.ForkCache(opts.trie);
        this.prefixCodeHashes = opts.prefixCodeHashes || false;
    }
    /**
     * Copies the current instance of the `StateManager`
     * at the last fully committed point, i.e. as if all current
     * checkpoints were reverted.
     */
    copy() {
        return new ForkStateManager({
            trie: this._trie.copy(false),
            prefixCodeHashes: this.prefixCodeHashes
        });
    }
    /**
     * Creates a storage trie from the primary storage trie
     * for an account and saves this in the storage cache.
     * @private
     */
    async _lookupStorageTrie(address) {
        // from state trie
        const account = await this.getAccount(address);
        const storageTrie = this._trie.copy(true);
        storageTrie.setContext(account.storageRoot, address.buf, storageTrie.blockNumber);
        // we copy checkpoints over only for the metadata checkpoints, not the trie
        // checkpoints.
        storageTrie.database().checkpoints = [];
        return storageTrie;
    }
    /**
     * Gets the storage value associated with the provided `address` and `key`.
     * This method returns the shortest representation of the stored value.
     * @param address - Address of the account to get the storage for
     * @param key - Key in the account's storage to get the value for. Must be 32
     * bytes long.
     * @returns {Promise<Buffer>} - The storage value for the account
     * corresponding to the provided address at the provided key. If this does not
     * exist an empty `Buffer` is returned.
     */
    async getContractStorage(address, key) {
        const trie = (await this._getStorageTrie(address));
        const value = await trie.get(key);
        return (0, rlp_1.decode)(value);
    }
}
exports.ForkStateManager = ForkStateManager;
//# sourceMappingURL=state-manager.js.map